import * as React from 'react';

import {winPanelListConfigurationContext, frameworkWinPanelList} from './winPanelListconfiguration';

const withWinPanelListConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <winPanelListConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkWinPanelList}/>
                );
            }}
        </winPanelListConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withWinPanelListConfiguration;